export default () => {

  $('[data-inv]').on('inview', (e, isInView) => {
    let timeout = $(e.currentTarget).data('inv');

    if (isInView) {
      setTimeout(() => {
        $(e.currentTarget).addClass('is-inv');
      }, timeout);
    }
  })
}
